import { styled } from '@mui/material';

import {
  useData,
  SystemMonitor,
  type WidgetConfigBase,
  type WidgetProps,
} from '#features';
import { Loader } from '#shared';

import { Widget } from '../base';

type Settings = Record<string, never>;
const config: WidgetConfigBase<Settings> = {};

const Root = styled(Widget)(({ theme: { spacing } }) => ({
  position: 'relative',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  minHeight: 0,
  padding: spacing(1),
}));

export const WidgetSystemMonitor = ({ instance }: WidgetProps<Settings>) => {
  const {
    rawData: allData,
    backendNetworkError,
    lastUpdateTime,
    dataErrors,
  } = useData();
  return (
    <Root config={config} instance={instance}>
      {() =>
        allData && lastUpdateTime ? (
          <SystemMonitor
            dataErrors={dataErrors}
            networkErrors={allData.networkErrors}
            lastUpdateTime={lastUpdateTime}
            backendNetworkError={backendNetworkError}
            insideWidget
          />
        ) : (
          <Loader />
        )
      }
    </Root>
  );
};

WidgetSystemMonitor.config = config;
